/**
 * ══ DIE GRÖSSE STEHT ALS `width` AM MARKER ════════════════════════════════
 * (User 23.10.2026: „Bild in der Notiz vergrößern/verkleinern … Größe wird
 * mit der Notiz gespeichert".) Gespeichert wird NUR die Breite in Pixeln als
 * HTML-Attribut — die Höhe folgt aus dem Seitenverhältnis (`height: auto`),
 * und ein `style` käme durch keinen Reiniger (`blockHtml.ts` verbietet es
 * aus gutem Grund). Ohne `width` steht das Bild wie bisher als kleines
 * Vorschaubild (höchstens 200 × 200, `.nf-feld img`).
 * ═══════════════════════════════════════════════════════════════════════════
 */

/** Kleinste Breite, auf die ein Notizbild gezogen werden kann. */
export const NOTIZBILD_MIN_BREITE = 60;
/** Obergrenze des Attributs — breiter ist kein Notizfeld; die Anzeige deckelt ohnehin auf die Feldbreite. */
export const NOTIZBILD_MAX_BREITE = 2000;

/** Ist das ein zulässiger `width`-Wert eines Notizbilds? */
export function istBildBreite(wert: string | null | undefined): boolean {
    if (!wert || !/^\d{1,4}$/.test(wert)) return false;
    const n = Number(wert);
    return n >= NOTIZBILD_MIN_BREITE && n <= NOTIZBILD_MAX_BREITE;
}

/** Eine gewünschte Breite auf die Grenzen bringen: mindestens 60 px, höchstens `max` (die Feldbreite). */
export function begrenzeBildBreite(px: number, max: number): number {
    const oben = Math.max(NOTIZBILD_MIN_BREITE, Math.min(NOTIZBILD_MAX_BREITE, Math.floor(max)));
    return Math.round(Math.min(oben, Math.max(NOTIZBILD_MIN_BREITE, px)));
}
